import React from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation, useParams } from "react-router-dom";

import SlideTransition from "@components/transitions/SlideTransitions";
import TransactionsContainer from "./TransactionContainer";

interface TransactionDetailsProps {
  path?: string;
  batchId?: string;
  userId?: number;
  merchantId?: number;
}
const TransactionDetails: React.FC<TransactionDetailsProps> = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

  const location = useLocation();
  const { userId = 0, merchantId = 0 } = (location.state ||
    {}) as TransactionDetailsProps;

  const { transactionID, ledger } = useParams();

  return (
    <SlideTransition
      className={`flex flex-col bg-bg-page-body ${
        isMobile ? "h-[100dvh] overflow-hidden" : "min-h-[100dvh]"
      }`}>
      <div
        className={`flex-1 overflow-y-scroll ${isMobile ? "min-h-0 mt-[72px]" : "mt-[72px]"}`}
        id="transaction-share">
        <TransactionsContainer
          transactionID={Number.parseInt(transactionID!)}
          ledger={ledger || ""}
          userId={userId}
          merchantId={merchantId}
        />
      </div>
    </SlideTransition>
  );
};
export default TransactionDetails;
